"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineNumber = exports.getTrees = exports.issuesToLineNumbers = void 0;
var types = require("../types");
var utils_1 = require("./utils");
function issuesToLineNumbers(fileContent, fileType, path) {
    var trees = getTrees(fileType, fileContent);
    return getLineNumber(path, fileType, trees);
}
exports.issuesToLineNumbers = issuesToLineNumbers;
function getTrees(fileType, fileContent) {
    assertFileType(fileType);
    var trees = utils_1.buildTreeForTypeMap[fileType](fileContent);
    if (Object.keys(trees).length === 0) {
        throw new Error('failed to create trees');
    }
    return trees;
}
exports.getTrees = getTrees;
function getLineNumber(path, fileType, trees) {
    assertFileType(fileType);
    var pathDetails = utils_1.getPathDetails(path.slice(), fileType);
    var treeNodes = trees[pathDetails.docId].nodes;
    return utils_1.findLineNumberOfGivenPath(treeNodes, pathDetails);
}
exports.getLineNumber = getLineNumber;
function assertFileType(fileType) {
    if (!Object.values(types.CloudConfigFileTypes).includes(fileType)) {
        throw new Error('Unknown format');
    }
}
//# sourceMappingURL=index.js.map